import { Box, Typography } from "@mui/material";
import ClientInfo from "features/mst_shipping_dest/components/ClientInfo";
import ShippingAddressTable from "features/mst_shipping_dest/components/ShippingAddressTable";
import useShippingAddressList from "features/mst_shipping_dest/hooks/useShippingAddressList";

/**
 * `ShippingDestList` is a React functional component that renders the shipping destination list page.
 * It includes a header, a section for master management, client information, and a table of shipping addresses.
 * @example
 * return (
 *   <ShippingDestList />
 * )
 * @returns {Element} The rendered component.
 */
function ShippingDestList() {
  const { addressList, hasMore, setPage, createShippingDest, isFetching, updateShippingDest } =
    useShippingAddressList();

  return (
    <>
      <Box
        sx={{
          p: { xs: 2, md: 2.5, lg: 5 },
          gap: { xs: 0, md: 2 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box minWidth="280px">
          <Typography
            fontWeight="medium"
            color="var(--gray-700)"
            fontSize={{ xs: 24, md: 28, lg: 23 }}
          >
            マスタ管理
          </Typography>
          <Typography
            marginLeft={4}
            fontWeight="medium"
            color="var(--gray-700)"
            fontSize={{ xs: 20, md: 28 }}
          >
            得意先一覧
          </Typography>
          <Typography
            marginLeft={4}
            fontWeight="medium"
            color="var(--gray-700)"
            fontSize={{ xs: 20, md: 28 }}
          >
            発送先管理
          </Typography>
        </Box>
        <ClientInfo addressList={addressList} />
      </Box>
      <ShippingAddressTable
        addressList={addressList}
        hasMore={hasMore}
        setPage={setPage}
        onCreate={createShippingDest}
        onUpdate={updateShippingDest}
        isFetching={isFetching}
      />
    </>
  );
}

export default ShippingDestList;
